import axiosInstance from "./axiosInstance";

const featureService = {
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('admin/users/dashboard');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
}

export default featureService
